import React from 'react';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import { format } from 'date-fns';
import { IRequestDetailComments } from './_types';
import { joinParams } from 'utils/study';
import { useMuiGrid } from 'utils/hooks/useMuiGrid';
import Header from 'components/Header/Header';
import { MuiGrid } from 'components/MuiGrid/MuiGrid';

const muiGridKey = 'requestDetailComments';

export const RequestDetailComments: React.FC<IRequestDetailComments> = ({ title, rows }) => {
  const { t } = useTranslation('Request');

  const { injectColumnWidthsIntoColumns, reorderColumnsByGridSettings } = useMuiGrid(muiGridKey);

  const columns = reorderColumnsByGridSettings(
    injectColumnWidthsIntoColumns([
      {
        field: 'createdWhen',
        headerName: t('createdWhen'),
        type: 'date',
        valueGetter: (value: any) => value && new Date(value),
        valueFormatter: (value: any) => value && format(value, 'dd. MM. yyyy HH:mm:ss'),
      },
      {
        field: 'createdBy',
        headerName: t('author'),
        valueGetter: (value: any, row: any) =>
          joinParams([get(row, 'createdBy.lastName'), get(row, 'createdBy.firstName')]),
      },
      {
        field: 'comment',
        headerName: t('comment'),
        valueGetter: (value: any, row: any) => get(row, 'text'),
      },
    ]),
  );

  return (
    <>
      <Header title={title} topMargin={true} />
      <MuiGrid
        gridKey={muiGridKey}
        rows={rows}
        columns={columns}
        withoutMaxHight={true}
        hideFooter={true}
        dataTour="request-detail-comments"
        initialSortMode={[{ field: 'createdWhen', sort: 'desc' }]}
      />
    </>
  );
};
